import React from 'react';
import getDoc from "../../qdoc";

export default class Tab_table extends React.Component {
  constructor(props) {
    super(props);

    this.getCube = getDoc.then(doc => {
      return doc.createSessionObject({
        qInfo: {
          qType: "visualization"
        },
        qHyperCubeDef: {
          qStateName: this.props.qStateName,          
          qDimensions: [{
            qDef: {
              qFieldDefs: ['Index'],
              qSortCriterias: [{ 
                // qSortByAscii: 1
              }]
            }, 
            qNullSuppression: false
          },
          {
            qDef: {
              qFieldDefs: ['Contributor Name'],
              qFieldLabels: ['Donor'],
              qSortCriterias: [{ 
                // qSortByAscii: 1
              }]
            }, 
            qNullSuppression: true
          }
          // ,
          // {
          //   qDef: {
          //     qFieldDefs: ['Year'],
          //     qSortCriterias: [{ 
          //       // qSortByAscii: 1
          //     }]
          //   }, 
          //   qNullSuppression: true
          // }
        ],
          qMeasures: [
          {
            qDef: {
              qDef: "num(sum([Total Amount]),'$#,##0.00')",
              qLabel: 'Amount'
            },
            qSortBy: {
              qSortByNumeric: -1
            }
          }
        ],
          qInterColumnSortOrder: [2]
        }
      });
    });

    this.state = {
      labels: [],
      data: [],
      updating: false,
      sortColumn: 2
    }
  }

  componentDidMount() {
    this.getLayout();
    this.update();
    this.getCube.then(cube => {
      cube.on('changed', () => {
        this.update();
      });
    });
  }

  update() {
    this.getHyperCubeData();
  }

  getLayout() {
    this.getCube.then(cube => {
      cube.getLayout().then(layout => {
        let labels = [];
        layout.qHyperCube.qDimensionInfo.forEach(row => { labels.push(row.qFallbackTitle); });
        layout.qHyperCube.qMeasureInfo.forEach(row => { labels.push(row.qFallbackTitle); });
        this.setState({ labels: labels });
      });
    });
  }

  getHyperCubeData() {
    this.getCube.then(cube => {
      cube.getHyperCubeData("/qHyperCubeDef", [{
        qTop: 0, 
        qLeft: 1, 
        qHeight: 10, 
        qWidth: 2
      }]).then(cubeData => {
        this.setState({data: cubeData[0].qMatrix});
      });
    });
  }

  // changeSort(event, i) {
  //   this.setState({ updating: true });
  //   this.getCube.then(cube => {
  //     cube.applyPatches([{
  //       qOp: "replace",
  //       qPath: "/qHyperCubeDef/qInterColumnSortOrder",
  //       qValue: JSON.stringify([i])
  //     }]).then(() => {
  //       this.setState({ updating: false, sortColumn: i });
  //     });
  //   });
  // }
  
  render() {
    return (
      <div className="container relative">
        <div style={{borderBottom:'2px solid #ECEEEF'}}>      
         <span className="textgreen">Top 10</span> Individual Contributions
        </div>
        <div className={`spinner ${this.state.updating ? 'updating' : ''}`}><i className="fa fa-spinner fa-spin fa-3x fa-fw"></i></div>
        <table className="table table-responsive table-sm">
          <thead>
            <tr>
              {this.state.labels.map((row,i) => {
                return i > 0 ? <th key={i} className={`${this.state.sortColumn === i ? 'active' : ''}`}>{row}</th> : null;
              })}
            </tr>
          </thead>
          <tbody>
            {this.state.data.map((row, i) => {
              return <tr key={i}>
                {row.map((item, i) => {
                  return <td key={i}>
                    {item.qText}
                  </td>;
                })}
              </tr>;
            })}
          </tbody>
        </table>
        {/* <div className="tablefooter mb-5">*Amount: Includes monetary and non-monetary donations. Non-monetary to monetary conversion was calculated as fair market value for the goods and/or services donated.</div> */}
      </div>
      
    );
  }
}


// WEBPACK FOOTER //
// ./components/Table/topdonorsKey.js